import { render, staticRenderFns } from "./RegistryResourcePage.vue?vue&type=template&id=5526d557"
import script from "./RegistryResourcePage.vue?vue&type=script&lang=js"
export * from "./RegistryResourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports